import React from "react";
import PropTypes from "prop-types";

import MuiDialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import DialogHeader from "ui/Dialog/DialogHeader";
import DialogActions from "ui/Dialog/DialogActions";
import Button from "ui/Button";

const CloseConfirmDialog = (props) => {
  const { onConfirm, onCancel, open } = props;

  const renderActionsFunc = () => {
    return (
      <>
        <Button
          id="confirm-dialog-cancel-button"
          variant="text"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          id="confirm-dialog-confirm-button"
          variant="contained"
          onClick={onConfirm}
        >
          Confirm
        </Button>
      </>
    );
  };

  return (
    <MuiDialog
      open={open}
      onClose={onCancel}
      slotProps={{ paper: { className: "close-confirm-width" } }}
      aria-labelledby="confirm-closing-dialog"
    >
      <DialogContainer>
        <DialogHeader
          title="Closing dialog"
          subTitle="Changes will be lost, proceed?"
        />
        <div style={{ height: "24px" }} />
        <DialogActions
          onClose={onCancel}
          renderActionsFunc={renderActionsFunc}
        />
      </DialogContainer>
    </MuiDialog>
  );
};

CloseConfirmDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default CloseConfirmDialog;

const DialogContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flex: "1 0 0",
  alignSelf: "stretch",
  borderRadius: "28px",
  background: "var(--surface-surface, #FCFDFF)",
}));
